import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 152px;
  border: 1px dashed ${({ theme }) => theme.palette.grey[400]};
  border-radius: 4px;
  svg {
    fill: ${({ theme }) => theme.palette.primary.dark};
    font-size: 24px;
  }
`;

export const Input = styled.input`
  height: 0;
  width: 0;
`;

export const AvatarWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  background-color: ${({ theme }) => theme.palette.secondary.dark};
  border-radius: 50%;
`;

export const UploadLabelWrapper = styled(Box)`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const UploadLabel = styled.label`
  color: ${({ theme }) => theme.palette.primary.dark};
  text-decoration: underline;
  cursor: pointer;
`;

export const UploadText = styled(Typography)``;

export const Description = styled(Typography)`
  font-size: 14px !important;
  color: ${({ theme }) => theme.palette.grey[700]};
`;
